<template>
  <div class="vacancy-card" :style="{ borderColor: color }">
    <div class="vacancy-card--description">
      <div class="vacancy-card--title">
        <h1>{{ title }}</h1><small>{{ vacancy_status !== 1 ? 'Vaga já Finalizada' : '' }}</small>
        {{ location }}
        <div
            v-if="vacancy_company_name"
        >
          <strong>Empresa: </strong> <span>{{ vacancy_company_name }}</span>
        </div>
      </div>
      <div
        v-if="
          vacancy_published_at.length > 0 || talent_applicated_at.length > 0
        "
        class="vacancy-card--subtitle"
      >
        <p>
          {{
            `${
              isOpen
                ? `Vaga aberta em  ${vacancy_published_at}`
                : (talent_withdrawal === null) 
                  ?`Candidatura realizada no dia ${talent_applicated_at}`
                  : 'Você desistiu dessa Vaga'
            }`
          }}
        </p>
      </div>
    </div>
    <div class="vacancy-card--actions">
      <button
        class="vacancy-card-btn-cancel"
        @click="handleUnsubscribe"
        v-if="displayUnsubscribe && (talent_withdrawal === null)"
      >
        Desistir
      </button>
      <vs-button
        v-else-if="displayUnsubscribe"
        color="primary"
        type="filled"
        class="mr-2"
        @click="handleReApply"
        :disabled="vacancy_status !== 1"
      >
        Candidatar-se Novamente
      </vs-button>
      <vs-button
        color="success"
        type="filled"
        class="mr-2"
        @click="handleTrainForInterview"
        v-if="displayUnsubscribe && (talent_withdrawal === null) && vacancy_status === 1"
      >
        Treinar para Entrevista
      </vs-button>
      <vs-button
        color="primary"
        type="border"
        @click="
          $router.push({
            name: 'vacancy-detail',
            params: { vacancy, isOpen, isSimilar: false }
          })
        "
      >
        {{ `${!show_details ? "Ver detalhes" : "Ocultar detalhes"}` }}
      </vs-button>
    </div>
    <vs-popup title="Desistindo da Candidatura" :active.sync="popupActive">
      <vs-row>
        <vs-col
          class="mb-8"
          vs-type="flex"
          vs-align="center"
          vs-justify="end"
          vs-w="12"
        >
          <p>
            Você está prestes a desistir da sua candidatura na vaga
            <b>{{ title.substring(0,30)+"..." }}</b>. Poderia nos contar porque está fazendo isto?
          </p>
        </vs-col>

        <v-select
          class="vacancy-card-select"
          name="unsubscribe"
          v-model="unSubscribe"
          :options="unsubscribeOptions"
          placeholder="Selecione um motivo"
        >
        </v-select>

        <vs-col
          class="px-0 flex-row-reverse teste"
          vs-type="flex"
          vs-align="center"
          vs-justify="end"
          vs-w="12"
        >
          <vs-button
            class="mx-1"
            @click="doApplication"
            color="primary"
            type="filled"
          >
            Desistir
          </vs-button>
          <vs-button
            class="mx-1"
            @click="popupActive = false"
            color="dark"
            type="flat"
          >
            Cancelar
          </vs-button>
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
import vSelect from "vue-select";

export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    displayUnsubscribe: {
      type: Boolean,
      required: true
    },
    vacancy: {
      type: Object,
      required: true
    },
    application: {
      type: Object,
      required: false
    }
  },
  data: () => ({
    location: "",
    show_details: false,
    popupActive: false,
    isForms: false,
    unSubscribe: "",
    unsubscribeOptions: [
      "Não quero justificar",
      "Recebi uma outra proposta",
      "Me candidatei na vaga errada",
      "Tive problemas no processo seletivo",
      "Outro"
    ]
  }),
  computed: {
    ...mapState("company", ["company"]),

    color() {
      if(this.vacancy_status === 1)
        return this.company.base_hexcolor || "#1551b1";
      else
        return "#cecece";
    },

    title() {
      return this.vacancy !== undefined && this.vacancy.hasOwnProperty("title")
        ? this.vacancy.title
        : "";
    },

    vacancy_status() {
      return this.vacancy !== undefined && this.vacancy.hasOwnProperty("vacancy_status_id")
        ? this.vacancy.vacancy_status_id
        : "";
    },

    description() {
      return this.vacancy != undefined &&
        this.vacancy.hasOwnProperty("description")
        ? this.vacancy.description
        : "";
    },

    vacancy_published_at() {
      return this.vacancy != undefined &&
        this.vacancy.hasOwnProperty("published_at")
        ? this.vacancy.published_at
        : "";
    },

    vacancy_company_name() {
      return this.vacancy != undefined &&
        this.vacancy.hasOwnProperty("company") &&
        this.vacancy.company.hasOwnProperty("name")
        ? this.vacancy.company.name
        : null;
    },

    talent_applicated_at() {
      return this.vacancy != undefined &&
        this.vacancy.hasOwnProperty("applications") &&
        this.vacancy.applications.length > 0
        ? new Date(this.vacancy.applications[0].created_at).toLocaleString(
            "pt-BR"
          )
        : "";
    },

    talent_withdrawal(){
      return this.vacancy != undefined &&
        this.vacancy.hasOwnProperty("applications") &&
        this.vacancy.applications.length > 0
        ? this.vacancy.applications[0].application_withdrawal_id
        : null
    },

    showLocation() {
      return (
        this.vacancy &&
        this.vacancy.show_location &&
        this.vacancy.show_location == 1
      );
    }
  },
  methods: {
    handleRedirectToApplicationProcess() {
      const { params } = this.$router.history.current;

      this.$router.push({
        name: "application-process",
        params: {
          ...params,
          step_id: this.step_id,
          vacancy_id: this.vacancy.id
        }
      });
    },
    async doApplication() {
      try {
        this.popupActive = false;
        this.$vs.loading();

        const body = {
          application_id: this.vacancy.applications[0].id,
          description: this.unSubscribe
        };

        const response = await this.$http.post(
          `/api/v2/applications-withdrawal/`,
          body
        );

        if (response.status == 200) {
          this.$vs.notify({
            title: "Candidatura removida com sucesso!",
            text: response.data.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });
        }
        this.$vs.loading.close();
        if (this.isForms) {
          this.handleRedirectToApplicationProcess();
        } else {
          this.$router.back();
        }
      } catch (error) {
        this.popupActive = false;
        this.$vs.loading.close();

        this.$vs.notify({
          title: "Falha ao Remover candidatura",
          text:
            "Falha ao realizar o procedimento contate a nossa equipe de suporte",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      }
    },

    handleUnsubscribe() {
      this.popupActive = true;
    },

    async handleReApply() {
      try {
        this.$vs.loading();

        const response = await this.$http.put(`/api/v1/applications/${this.vacancy.applications[0].id}/restore`);

        if (response.status == 200) {
          this.$vs.notify({
            title: "Você se candidatou novamente à vaga",
            text: response.data.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });
        }
        this.$vs.loading.close();
        this.handleRedirectToApplicationProcess();
      } catch (error) {
        this.$vs.loading.close();

        this.$vs.notify({
          title: "Falha ao candidatar-se novamente à vaga",
          text:
            "Falha ao realizar o procedimento tente novamente mais tarde",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      }
      window.woopra.track("reapply-click", {
        vacancy_id: this.vacancy.id,
        application_id: this.vacancy.applications[0].id,
      });

    },

    handleTrainForInterview() {
      const token = this.$store.getters["auth/token"];
      const interviewLink = `${process.env.VUE_APP_TRAINING_INTERVIEW_URL}/interview/${this.vacancy.applications[0].talent_uuid}?app_id=${this.vacancy.applications[0].id}&token=${token}`;
      window.woopra.track("interview-training-click", {
        app_id: this.vacancy.applications[0].id,
        talent_uuid: this.vacancy.applications[0].talent_uuid,
        vacancy_id: this.vacancy.id
      });
      window.open(interviewLink, '_blank');
    }
  },
  components: {
    "v-select": vSelect
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/talent/components/vacancycard.scss";
</style>
